export class ListCustData {
    customerCode: string;
    product: string;
    source: string;
    leadType: string;
    buyDate: string;
    leadStatusCode: string;
    leadSubStatusCode: string;
    userId: string;
    countryCode: string;
    customerName: string;
    enquiryId: string;
    vin: string;
    leadStatus: string;
    followUp: string;
    followUpDate: string;
    enquiryRemarks: string;
    contractNumber: string

    constructor(
        customerCode: string,
        vin: string,
        product: string,
        source: string,
        leadType: string,
        buyDate: string,
        leadStatusCode: string,
        leadSubStatusCode: string,
        userId: string,
        countryCode: string,
        followUpDate: string,
        enquiryRemarks: string,
        contractNumber: string
    ) {
        this.source=source;
        this.customerCode=customerCode;
        this.userId= userId;
        this.countryCode= countryCode
        this.product = product;
        this.vin=vin;
        this.leadStatusCode = leadStatusCode;
        this.leadType= leadType;
        this.buyDate = buyDate;
        this.leadSubStatusCode = leadSubStatusCode;
        this.followUpDate=followUpDate;
        this.enquiryRemarks=enquiryRemarks;
        this.contractNumber=contractNumber;
    }
}
